
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brochure",
      function () {
        return require("private-next-pages/brochure/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brochure"])
      });
    }
  